import { render, staticRenderFns } from "./CkModalEvents.vue?vue&type=template&id=4b358466&scoped=true"
import script from "./CkModalEvents.vue?vue&type=script&lang=js"
export * from "./CkModalEvents.vue?vue&type=script&lang=js"
import style0 from "./CkModalEvents.vue?vue&type=style&index=0&id=4b358466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b358466",
  null
  
)

export default component.exports